/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    MONTH: 30,
    YEAR: 365,
};
